<template>
  <div
    class="col-lg-2 col-md-3 col-6"
    v-for="(footer, key) in FooterGroup"
    :key="key"
  >
    <h6 class="pt-2" style="font-weight: 600">{{ footer.title }}</h6>
    <p class="pt-4">{{ footer.subtitle_1 }}</p>
    <p>{{ footer.subtitle_2 }}</p>
    <p>{{ footer.subtitle_3 }}</p>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      lang: "en",
      FooterGroup: [],
    };
  },
  beforeMount() {
    this.ActionUpdateStore();
  },
  methods: {
    ActionUpdateStore() {
      const url =
        "https://au.api.vezham.com/widgets/stringcms/v1/pages/footer/collections/group-5/entities/views";
      const config = {
        headers: {
          "Content-Type": "application/json",
          "X-WORKSPACE-WALLET-ADDRESS":
            "0wxkALTb6mKr4ydf502UyB8jldFszVYXS1EawFD4S9kMZpG7WLL2bpSwPuVRe49/FMa2voEmo+MlyMF8LzdEw==",
        },
      };
      let data = {
        language_code: this.lang,
        sort_by: [
          {
            field: "order",
            order: "asc",
          },
        ],
      };
      axios
        .post(url, data, config)
        .then(({ data }) => {
          if (data.meta.status != "success") {
            this.FooterGroup = [];
            return;
          } else if (data.data.length == 0) {
            this.FooterGroup = [];
            return;
          }
          this.FooterGroup = data.data;
        })
        .catch(() => {});
    },
  },
};
</script>

<style></style>
